export default __webpack_public_path__ + "static/media/circle-02.a1e0c2ba.png";